// extracted by mini-css-extract-plugin
export default {"readonlyForm":"readonlyForm___vLlXo"};